<template>
  <v-row>
    <v-col
      v-if="diagnosticStats.tsa"
      cols="3"
      class="pt-0"
    >
      <v-card class="fill-height rounded-lg d-flex flex-column">
        <v-card-title class="pb-0">
          {{ $t('card_title.tsa') }}
        </v-card-title>
        <v-card-text class="flex-grow-1 d-flex align-center justify-center">
          <v-progress-circular
            :value="diagnosticStats.tsa.norm_super_comp_value"
            :size="200"
            :width="25"
            :rotate="-90"
            :color="getColorForValue(diagnosticStats.tsa.norm_super_comp_value, 100)"
          >
            <div class="text-h4 font-weight-bold">
              {{ diagnosticStats.tsa.norm_super_comp_value }}%
            </div>
          </v-progress-circular>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col :cols="diagnosticStats.tsa ? 9 : 12">
      <line-chart
        :raw-data="sortedDiagnosticStats"
        :chart-value-keys="[ { key: composite === 'composite' ? 'comp_value' : 'norm_comp_value', type: 'bar' } ]"
        x-value="key"
        :xaxis="{
          labels: {
            rotate: -45,
            hideOverlappingLabels: false,
            trim: true
          },
          categories: sortedDiagnosticStats.map(group => group.name)
        }"
        :yaxis="[composite === 'composite' ? {min: -3, max: 3} : {min: 0, max: 100}]"
        :fill="{ type: 'solid', opacity: [0.5] }"
        :tooltip="{ y: {title: {formatter: () => $t('tooltip.value')} }}"
      >
        <template v-slot:header>
          <v-row
            align="center"
          >
            <v-col>
              <v-card-title class="px-6">
                <div class="subtitle-2 grey--text text--grey-100">
                  {{ $t('card_title.composite_graph') }}
                </div>
              </v-card-title>
            </v-col>
            <v-col
              class="mr-2"
              cols="auto"
            >
              <v-btn-toggle
                v-model="composite"
                mandatory
                class="mr-6"
                color="primary"
              >
                <v-btn
                  small
                  class="text-none"
                  value="composite"
                >
                  {{ $t('card.composite_graph.display_option.composite') }}
                </v-btn>
                <v-btn
                  small
                  class="text-none"
                  value="normalized"
                >
                  {{ $t('card.composite_graph.display_option.normalized') }}
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </template>
      </line-chart>
    </v-col>
  </v-row>
</template>
<script>
import LineChart from '@/components/charts/LineChart.vue'
import { getColorForValue } from '@/utils/helpers'
import { sortBy } from 'lodash'

export default {
  name: 'PlayerDiagnosticCompositeGraph',
  components: { LineChart },
  props: {
    player: {
      type: Object,
      required: true
    },
    diagnosticStats: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    composite: 'composite'
  }),
  computed: {
    sortedDiagnosticStats() {
      const statsWithName = this.diagnosticStats.groups.map(group => {
        return {
          ...group,
          name: this.$t(`diagnostics.groups.${group.group_id}`)
        }
      })
      return sortBy(statsWithName, ['name'])
    }
  },
  methods: { getColorForValue }
}
</script>

<style scoped>

</style>
